<nsc-card>
  <nsc-card-title>Fee Summary</nsc-card-title>
  <nsc-card-content>
    <div class="row">
      <div class="col-12 col-lg-6">

        <div class="nsc-table nsc-table--no-title">
          @if (fees.transcriptFee !== 0) {
            <div class="nsc-table__row" >
              <div class="nsc-table__col nsc-table__col--label">
                <strong class="nsc-txt">Transcript Quantity Fee</strong>
              </div>
              <div class="nsc-table__col nsc-table__col--value">
                <strong class="nsc-txt">{{ fees.transcriptFee | currency }}</strong>
              </div>
            </div>
          }

          @if (fees.deliveryFee !== 0 ) {
            <div class="nsc-table__row" >
              <div class="nsc-table__col nsc-table__col--label">
                <strong class="nsc-txt">{{ fees.deliveryFeeDescription}}</strong>
              </div>
              <div class="nsc-table__col nsc-table__col--value">
                <strong class="nsc-txt">  {{ externalVendorFeeApplicable && printVendorDeliveryFeePaidBy!=='S' ? 'TBD' : (fees.deliveryFee | currency) }}</strong>
              </div>
            </div>
          }

          @if (fees.transcriptTypeFee !== 0) {
            <div class="nsc-table__row" >
              <div class="nsc-table__col nsc-table__col--label">
                <strong class="nsc-txt">Transcript Type Fee</strong>
              </div>
              <div class="nsc-table__col nsc-table__col--value">
                <strong class="nsc-txt">{{ fees.transcriptTypeFee | currency }}</strong>
              </div>
            </div>
          }

          @if (fees.shippingAndHandlingFee !== 0) {
            <div class="nsc-table__row" >
              <div class="nsc-table__col nsc-table__col--label">
                <strong class="nsc-txt">Shipping and Handling Fee</strong>
              </div>
              <div class="nsc-table__col nsc-table__col--value">
                <strong class="nsc-txt">{{ fees.shippingAndHandlingFee | currency }}</strong>
              </div>
            </div>
          }

          @if (fees.onlineProcessingFee !== 0) {
            <div class="nsc-table__row" >
              <div class="nsc-table__col nsc-table__col--label">
                <strong class="nsc-txt">Online Processing Fee</strong>
              </div>
              <div class="nsc-table__col nsc-table__col--value">
                <strong class="nsc-txt">{{ fees.onlineProcessingFee | currency }}</strong>
              </div>
            </div>
          }

          <div class="nsc-table__row nsc-table__row--total" >
            <div class="nsc-table__col nsc-table__col--label nsc-table__col--label--total">
              <strong>{{ totalFeeLabel }}</strong>
            </div>
            <div class="nsc-table__col nsc-table__col--value nsc-table__col--total">
              <strong>{{ externalVendorFeeApplicable && printVendorDeliveryFeePaidBy!=='S' ? '' : (fees.totalFee | currency) }}</strong>
              @if ((isSPDESchool || isFASTSchool || (isTNSchool && fees.totalFee === 0))) {
                <button (click)="viewTotalFeeTNDetails()" mat-icon-button aria-label="info">
                  <mat-icon>info</mat-icon>
                </button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </nsc-card-content>
</nsc-card>